<script>
import Auth from "../../layouts/auth";
import appConfig from "../../../../app.config";

export default {
  page: {
    title: "Mantenimimento",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Auth,
  },
};
</script>

<template>
  
    <div class="mt-5 mb-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12">
            <div class="text-center">
              <img
                src="@/assets/images/animat-rocket-color.gif"
                alt=""
                height="160"
              />
              <h3 class="mt-1">Disculpe esta página está en mantenimiento</h3>
              

          
              <!-- end row-->
            </div>
            <!-- end /.text-center-->
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->
      </div>
      <!-- end container -->
    </div>
    <!-- end page -->
  
</template>
